import React from 'react';
import { branch } from 'recompose';
import { withRouter } from 'react-router';
import withCreatePage from 'hocs/extends/withCreatePage'
import withEditPage from 'hocs/extends/withEditPage'
import TagBannerController from './TagBannerController'

// const initialMenu = megaMenuData

const initialMenu = {
  name: '',
  data: {},
};

const CreateOrEditTagBanner = (
  branch(
    props => props.params.id,
    withEditPage({
      resourceName: 'tagBanner',
      getInitialResource: () => ({}),
    }),
    withCreatePage({
      resourceName: 'tagBanner',
      initialState: initialMenu,
    }),
  )
)(TagBannerController);

CreateOrEditTagBanner.propTypes = {};
CreateOrEditTagBanner.defaultProps = {};

export default withRouter(CreateOrEditTagBanner);



// WEBPACK FOOTER //
// ./src/pages/Banners/children/TagBanners/CreateOrEditTagBanner.js